import React, {useState} from "react";
import {TouchableOpacity, View, StyleSheet} from "react-native";
import PtText from "../core/pt-text/pt-text";
import {styleVars} from "../../app-style-vars";
import PtIcon from "../core/pt-icon/pt-icon";
import {getTranslation} from "../../helpers/getTranslation";
import PtDuePaymentsSearch from "./pt-due-payments-search";
import PtDuePaymentsFilter from "./pt-due-payments-filter";

const renderFiltersTrigger = (showFilters:any, toggleFilters:any) => {
  return (
    <View style={[styles.triggerContainer]}>
      <TouchableOpacity onPress={() => toggleFilters()}>
        <PtText style={{color:styleVars.boschDarkBlue}}>
          {showFilters ?
            <PtIcon iconName={'up'} iconSize={16}
                    style={{paddingRight: styleVars.rem(.5), color: styleVars.boschDarkBlue}}/>
            :
            <PtIcon iconName={'down'} iconSize={16}
                    style={{paddingRight: styleVars.rem(.5), color: styleVars.boschDarkBlue}}/>
          }
          {getTranslation('due.payments.show.filters.label')}
        </PtText>
      </TouchableOpacity>
    </View>
  )
}

const renderSearchTrigger = (showSearch:any, toggleSearch:any) => {
  return (
    <View style={[styles.triggerContainer]}>
      <TouchableOpacity onPress={() => toggleSearch()}>
        <PtText style={{color:styleVars.boschDarkBlue}}>
          {showSearch ?
            <PtIcon iconName={'up'} iconSize={16}
                    style={{paddingRight: styleVars.rem(.5), color: styleVars.boschDarkBlue}}/>
            :
            <PtIcon iconName={'down'} iconSize={16}
                    style={{paddingRight: styleVars.rem(.5), color: styleVars.boschDarkBlue}}/>
          }
          {getTranslation('due.payments.show.search.label')}
        </PtText>
      </TouchableOpacity>
    </View>
  )
}

const renderResetTrigger = (resetSearchAndFilters:any) => {
  return (
    <View style={[styles.triggerContainer]}>
      <TouchableOpacity onPress={() => resetSearchAndFilters()}>
        <PtText style={{color:styleVars.boschDarkBlue}}>
          <PtIcon iconName={'reset'} iconSize={16} style={{paddingRight:styleVars.rem(.5), color:styleVars.boschDarkBlue}}/>
          {getTranslation('due.payments.reset.label')}
        </PtText>
      </TouchableOpacity>
    </View>
  )
}

export default function PtDuePaymentsSearchFilterWrapper(props:any) {

  /** data */
  const searchOptions = props.searchOptions ? props.searchOptions : [];
  const filtersOptions = props.filtersOptions ? props.filtersOptions : {};

  /** settings */
  const containerHidden = props.hide ? styles.containerHidden : null;
  const [showSearch, setShowSearch] = useState(props.showSearch || false);
  const [showFilters, setShowFilters] = useState(props.showFilters || false);

  /** pass through handlers */
  const duePaymentStatusFilterChangedHandler = props.duePaymentStatusFilterChangedHandler;
  const duePaymentTypeFilterChangedHandler = props.duePaymentTypeFilterChangedHandler;
  const startDateChangedHandler = props.startDateChangedHandler;
  const endDateChangedHandler = props.endDateChangedHandler;
  const applyFiltersHandler = props.applyFiltersHandler;
  const searchTermChangedHandler = props.searchTermChangedHandler;
  const searchTypeChangedHandler = props.searchTypeChangedHandler;
  const searchHandler = props.searchHandler;

  const toggleSearch = () => {
    setShowSearch(!showSearch);
  }

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  }

  const resetSearchAndFilters = () => {
    props.resetHandler();
  }

  /** renders */
  const getFiltersTrigger = renderFiltersTrigger(showFilters, toggleFilters);
  const getSearchTrigger = renderSearchTrigger(showSearch, toggleSearch);
  const getResetTrigger = renderResetTrigger(resetSearchAndFilters);

  return (
    <View style={[styles.wrapperContainer, containerHidden]}>
      <View style={[styles.actionsStrip]}>
        {getFiltersTrigger}
        {getResetTrigger}
        {getSearchTrigger}
      </View>
      <PtDuePaymentsSearch
        show={showSearch}
        searchOptions={searchOptions}
        requestParams={props.requestParams}
        searchTermChangedHandler = {searchTermChangedHandler}
        searchTypeChangedHandler = {searchTypeChangedHandler}
        searchHandler = {searchHandler}
      />
      <PtDuePaymentsFilter
        show={showFilters}
        filtersOptions={filtersOptions}
        requestParams={props.requestParams}
        duePaymentStatusFilterChangedHandler = {duePaymentStatusFilterChangedHandler}
        duePaymentTypeFilterChangedHandler = {duePaymentTypeFilterChangedHandler}
        startDateChangedHandler = {startDateChangedHandler}
        endDateChangedHandler = {endDateChangedHandler}
        applyFiltersHandler = {applyFiltersHandler}
      />
      {showSearch || showFilters ?
        <View style={[styles.actionsStrip]}>
          {showFilters ? getFiltersTrigger : <View style={[styles.triggerContainer]}/>}
          {getResetTrigger}
          {showSearch ? getSearchTrigger : <View style={[styles.triggerContainer]}/>}
        </View>
        : null
      }
    </View>
  )

}

const styles = StyleSheet.create({
  wrapperContainer: {
    marginVertical: styleVars.rem(.5),
  },
  containerHidden: {
    display: 'none',
  },
  actionsStrip: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: styleVars.boschLightGrayW75,
    padding: styleVars.rem(.5),
  },
  triggerContainer: {
    maxWidth: '30%'
  },
})